import React from "react";

import {
    Slider,
    Categories,
//     TrendingNow,
//     TrendingMain,
//     HighLight,
//     NewArrival,
//     ShoppingLink,
//     GiftGuide,
//     FurniturePlace,
//     FeelGoodFind,
//     SoulStyle,
} from "./includes";

function Theme1(props) {
    return (
        <>
            <Slider />

            <Categories />
            
            {/* <Slider />

            <ShoppingLink />

            <TopProduct />

            <TrendingNow />

            <TrendingMain />

            <HighLight />

            <NewArrival />

            <GiftGuide />

            <FurniturePlace />

            <FeelGoodFind />

            <SoulStyle /> */}
        </>
    );
}

export default Theme1;
